import { useEffect, useState } from "react";
import { dynamicImage } from "../../Service";
import { Image } from "../../AbstractElements";
import { getIndividualTemplate, getAllTemplates } from "../../Api/template";

const AdminTemplates = () => {
  const [allTemplates, setAllTemplates] = useState<any[]>([])

  useEffect(() => {
    const fetchTemplates = async () => {
      const response: any = await getAllTemplates()
      setAllTemplates(response.templates)
    }
    fetchTemplates()
  }, [])

  const handleClickPDF = async (templateId: string) => {
    const response: any = await getIndividualTemplate(templateId)
    if (response.status !== 200) {
      throw new Error("PDF not found");
    }

    // response.data is the Blob
    const blob = response.data;
    const blobUrl = URL.createObjectURL(blob);

    // Open in new tab
    window.open(blobUrl, "_blank");
  }

  return (
    <div className='page-body default-dashboard dashboard-2'>
      <div className="d-flex flex-column flex-md-row align-items-center gap-4 px-3">
        {
          allTemplates.map((template: any, index: number) => {
            return (
              <div
                key={index}
                style={{ backgroundColor: 'white', padding: '20px 20px 10px 20px', borderRadius: '8px', boxShadow: "0px 4px 10px rgba(39, 32, 120, 0.1)", cursor: 'pointer' }}
                onClick={() => handleClickPDF(template.id)}
              >
                <Image className="img-fluid for-light" src={dynamicImage("logo/PDF.png")} alt="doc" width={160} />
                <hr style={{ margin: '10px 0px' }} />
                <div className="mt-2" style={{ textAlign: 'center', fontWeight: 600 }}>{`${template.name} Template`}</div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default AdminTemplates;